import React from "react";
import { FiPhone } from "react-icons/fi";

const CallNowButton = ({
  name = "Call Now",
  bgColor = "bg-green-500",
  textColor = "text-white",
  textHoverColor = "hover:text-violet-950",
  showIcon = true,
  hoverColor = "hover:bg-violet-500",
  paddingx = "px-4",
  paddingy = "py-2",
  href = "tel:+919000566767",
}) => {
  return (
    <a
      href={href}
      className={`group relative inline-flex items-center justify-center rounded-sm ${bgColor}  p-2 transition duration-500 ease-in-out ${hoverColor}  px-4 py-2`}
    >
      {showIcon && <FiPhone size={20} className={`${textColor} mr-2`} />}
      <span
        className={`${paddingx} ${paddingy} text-center font-bold ${textColor} ${textHoverColor}`}
      >
        {name}
      </span>
    </a>
  );
};

export default CallNowButton;
